 document.addEventListener("DOMContentLoaded", function () {
      document.querySelectorAll(".hellow_title").forEach(el => {
        const words = el.textContent.trim().split(" ");
        if (words.length >= 2) {
          const colored = `<span style="color:#fff;">${words[0]} ${words[1]}</span>`;
          const rest = words.slice(2).join(" ");
          el.innerHTML = `${colored} ${rest}`;
        }
      });
    });